<template>
        <crud-update :open="open"
                 :loading="loading"
                 :title="title"
                 :errorMessage="errorMessage"
                 @update="update"
                 @close="$emit('close')"
    >
         <field-permission-form ref="form" v-model="form" :input-errors="inputErrors" :role="item.role" />
    </crud-update>
</template>

<script>

    import FieldPermissionProvider from "../../../../providers/FieldPermissionProvider";

    import {CrudUpdate, ClientError} from '@dracul/common-frontend'

    import FieldPermissionForm from "../FieldPermissionForm";



    export default {
        name: "FieldPermissionUpdate",

        components: { FieldPermissionForm, CrudUpdate },

        props:{
          open: {type: Boolean, default: true},
          item: {type: Object, required: true}
        },

        data() {
            return {
                title: 'surety.fieldPermission.editing',
                errorMessage: '',
                inputErrors: {},
                loading: false,
                id: this.item.id,
                form: {
                    role: this.item.role ? this.item.role.id : null,
                    entity: this.item.entity,
                    fields: this.item.fields
                }
            }
        },
        methods: {
            update() {
                if (this.$refs.form.validate()) {
                    this.loading = true
                    FieldPermissionProvider.updateFieldPermission(this.id, this.form).then(r => {
                            if (r) {
                                this.$emit('itemUpdated',r.data.updateFieldPermission)
                                this.$emit('close')
                            }
                        }
                    ).catch(error => {
                         let clientError = new ClientError(error)
                         this.inputErrors = clientError.inputErrors
                         this.errorMessage = clientError.i18nMessage
                    }).finally(() => this.loading = false)
                }

            }
        },
    }
</script>

<style scoped>

</style>

